<template>
  <div>
    <div class="sidebar waajo-inbox-sidebar" id="sidebarLeft">
      <div class="sidebar-inner v-slimscroll">
        <div class="sidebar-menu waajo-inbox">
          <div class="waajo-inbox-head">
            <div class="waajo-inbox-account">
              <div class="waajo-inbox-account-icon">
                <i class="fa fa-whatsapp"></i>
                <Skeleton
                  v-if="!!loadingStatus"
                  :count="1"
                  :width="'10px'"
                  :height="'10px'"
                />
                <span v-else class="waajo-inbox-status">
                  <i
                    title="Terhubung"
                    class="fa fa-circle text-success"
                    v-if="isOnlineData.status == 1"
                  ></i>
                  <i
                    title="Tidak terhubung"
                    class="fa fa-circle text-danger"
                    v-else
                  ></i>
                </span>
              </div>

              <div class="waajo-inbox-account-copy">
                <strong>{{ agentSession.license_phone_number }}</strong>
                <span
                  v-if="licenseName"
                  class="waajo-inbox-license-name"
                  :title="licenseName"
                >{{ licenseName }}</span>
                <small>
                  <i class="la la-user"></i>
                  <span class="waajo-inbox-agent-name">{{ agentSession.first_name }}</span>
                  <span
                    v-if="agentSession.is_owner == 1"
                    class="waajo-inbox-owner-badge"
                  >Pemilik</span>
                </small>
              </div>
            </div>

            <div class="waajo-inbox-search">
              <i class="fa fa-search"></i>
              <input
                v-model="serverParam.keywords"
                type="text"
                @change="filterRoomByKeywords"
                placeholder="Cari percakapan..."
              />
              <div class="dropdown waajo-inbox-filter">
                <button
                  type="button"
                  class="waajo-inbox-filter-btn"
                  data-toggle="dropdown"
                  title="Opsi percakapan"
                >
                  <i class="fa fa-sliders"></i>
                  <i
                    class="fa fa-circle text-success waajo-filter-dot"
                    v-if="filterRoomAdvance.tags_filter == true"
                  ></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    class="dropdown-item"
                    @click="showFilter"
                    href="#"
                    data-toggle="modal"
                    data-target="#add_filters"
                  >
                    <i class="fa fa-tag"></i>
                    Filter Percakapan
                  </a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a
                    class="dropdown-item"
                    @click.prevent="showDirectChats"
                    href="#"
                  >
                    <i class="fa fa-send-o"></i>
                    Chat Langsung
                  </a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a
                    @click="resolveAll"
                    class="dropdown-item"
                    href="javascript:void(0)"
                  >
                    <i class="fa fa-check"></i>
                    Selesaikan Semua
                  </a>
                  <a
                    @click="readAll"
                    class="dropdown-item"
                    href="javascript:void(0)"
                  >
                    <i class="fa fa-envelope-open-o"></i>
                    Tandai Semua Dibaca
                  </a>
                  <div role="separator" class="dropdown-divider"></div>
                  <a
                    @click="clearAll"
                    class="dropdown-item text-danger"
                    href="javascript:void(0)"
                  >
                    <i class="fa fa-trash"></i>
                    Hapus Semua
                  </a>
                </div>
              </div>
            </div>

            <button
              type="button"
              class="waajo-inbox-live"
              @click.prevent="showDirectChats"
            >
              <span class="waajo-inbox-live-icon">
                <i class="fa fa-comments-o"></i>
              </span>
              <span class="waajo-inbox-live-copy">
                <strong>Chat Langsung</strong>
                <small>Mulai chat atau tambah kontak</small>
              </span>
              <i class="fa fa-chevron-right"></i>
            </button>

            <div class="waajo-inbox-tabs">
              <button
                @click.prevent="filterRoomByOptions('')"
                type="button"
                :class="{ 'is-active': currentOptionsValue == '' }"
              >
                Semua
              </button>
              <button
                @click.prevent="filterRoomByOptions('unread')"
                type="button"
                :class="{ 'is-active': currentOptionsValue == 'unread' }"
              >
                Belum Dibaca
              </button>
              <button
                @click.prevent="filterRoomByOptions('resolved')"
                type="button"
                :class="{ 'is-active': currentOptionsValue == 'resolved' }"
              >
                Selesai
              </button>
            </div>
          </div>

          <ul class="waajo-room-list">
            <li v-if="initLoading" class="waajo-room-loading">
              <Skeleton :count="3" />
            </li>
            <li v-else-if="roomListArr.length < 1" class="waajo-room-empty">
              Belum ada percakapan
            </li>

            <li
              :ref="'ref-' + rowArr.id"
              v-for="(rowArr, index) in roomListArr"
              :key="rowArr.id || index"
              class="waajo-room-item"
              :class="{ active: activeRoomId == rowArr.id }"
            >
              <a
                href="javascript:void(0)"
                class="waajo-room-link"
                @click="
                  switchRoom(
                    rowArr.id,
                    rowArr.room_title,
                    rowArr.room_photo,
                    rowArr.provider
                  )
                "
              >
                <span class="waajo-room-avatar">
                  <avatar
                    style="width: 38px; height: 38px;"
                    :username="rowArr.room_title"
                    v-if="rowArr.room_photo == ''"
                  ></avatar>
                  <img
                    class="rounded-circle"
                    alt
                    v-lazy="rowArr.room_photo"
                    v-else
                  />
                  <span class="waajo-room-dot"></span>
                </span>

                <span class="waajo-room-main">
                  <span class="waajo-room-top">
                    <strong class="waajo-room-name" :title="rowArr.room_title">
                      {{ rowArr.room_title }}
                    </strong>
                    <small class="waajo-room-time">
                      {{ showDateRoomList(rowArr.update_datetime) }}
                    </small>
                  </span>

                  <span class="waajo-room-bottom">
                    <small
                      class="waajo-room-snippet"
                      :title="rowArr.room_last_chat_message"
                    >
                      {{ rowArr.room_last_chat_message }}
                    </small>
                    <span
                      :ref="'ref-unread-' + rowArr.id"
                      v-show="rowArr.num_unread > 0"
                      class="waajo-unread-badge"
                    >
                      {{ rowArr.num_unread }}
                    </span>
                  </span>

                  <span class="waajo-room-flags">
                    <small
                      :ref="'ref-unserved-' + rowArr.id"
                      v-show="rowArr.num_unread > 0"
                      class="waajo-unserved"
                    >
                      Belum dilayani
                    </small>
                    <span
                      v-show="!!rowArr.is_resolved_id"
                      class="waajo-resolved"
                    >
                      Selesai
                    </span>
                  </span>
                </span>
              </a>
            </li>
          </ul>

          <infinite-loading-contact
            spinner="spiral"
            :identifier="infiniteId"
            @infinite="getRoomList"
          >
            <div slot="spinner">
              <span v-if="loading">Memuat...</span>
            </div>
            <div slot="no-more">
              <span
                v-if="
                  this.serverParam.totalRecords > 0 &&
                  this.serverParam.rendered >= this.serverParam.totalRecords
                "
              >
                Tidak ada percakapan lagi
              </span>
              <span v-if="this.serverParam.totalRecords == 0">
                Tidak ada percakapan
              </span>
              <span
                v-if="
                  this.serverParam.totalRecords > 0 &&
                  this.serverParam.rendered == 0
                "
              >
                Tidak ada percakapan
              </span>
            </div>
            <div slot="no-results">
              <span v-if="this.serverParam.totalRecords == 0">
                Percakapan tidak ditemukan
              </span>
              <span v-else>Tidak ada percakapan lagi</span>
            </div>
          </infinite-loading-contact>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getWhatsappJid, showDateRoomList } from "@/utils/helper";
import { mapGetters } from "vuex";
import { Skeleton } from "vue-loading-skeleton";
import InfiniteLoading from "vue-infinite-loading";
// import { useSound } from '@vueuse/sound';
// import incomingSound from '@/assets/sounds/incoming.mp3'
// audioFile.play();
import Avatar from 'vue-avatar'

export default {
  components: {
    InfiniteLoadingContact: InfiniteLoading,
    Skeleton,Avatar
  },
  props: {},
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    },
    licenseName() {
      const session = this.agentSession || {};
      return typeof session.license_name === "string"
        ? session.license_name.trim()
        : "";
    },
    isFilterAdvanceClear() {
      return this.$store.state.omniroom.isFilterAdvanceClear;
    },
    isFilterAdvanceActive() {
      return this.$store.state.omniroom.isFilterAdvanceActive;
    },
    filterRoomAdvance() {
      return this.$store.state.omniroom.filterRoomAdvance;
    },
    ...mapGetters([
      "roomListArr",
      "agentSession",
      "activeRoomId",
      "NEW_NUM_UNREAD_MESSAGE_ROOM_Data"
    ]),
    numUnreadMessage() {
      return this.$store.state.omniroom.numUnreadMessage;
    },
    RefreshRoomData() {
      return this.$store.state.pusher.RefreshRoomData;
    },
    RemoveRoomData() {
      return this.$store.state.pusher.RemoveRoomData;
    },
    RefreshSenderNumberData() {
      return this.$store.state.pusher.RefreshSenderNumberData;
    },
    currentpage() {
      return this.$route.path;
    }
  },
  data() {
    // const incomingSound = new Audio("@/assets/sounds/incoming.mp3");

    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      currentOptionsValue: "",
      currentTitle: "",
      appTitle: process.env.VUE_APP_TITLE,
      incomingSound: process.env.VUE_APP_SOUNDS_INCOMING,
      newData: [],
      infiniteId: +new Date(),
      initLoading: false,
      loading: false,
      activeClass: "active",
      // activeRoomId: ""
      activeId: "",
      queryRoomOpening: false,
      loadingStatus: false,
      isOnlineData: {
        message: "",
        status: 0,
        checkIsOnline: null
      },
      serverParam: {
        keywords: "",
        options: "",
        tags_filter: false,
        untag: false,
        tags_id: [],
        page: 0,
        perPage: 30,
        rendered: 0,
        totalRecords: 0
      },
      paramNumUnread: {
        keywords: "",
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      }
    };
    //  isactive : true
  },
  watch: {
    RefreshSenderNumberData: {
      handler: function (val, oldVal) {
        if (val != oldVal && val != "") {
          //maka refresh
          this.$fire({
            title: "Preparing new sender number",
            text: "please wait ...",
            type: "success",
            timer: 3000
          }).then(async r => {
            // await this.$router.push("/omni");
            if (this.memberSessionArr.roles.length == 1) {
              window.location.href = this.baseUrl + "/omni/connect-to-agent-owner?license_id=" + val + "&agent_id=" + this.agentSession.id
            } else {
              window.location.href = this.baseUrl + "/omni/connect-to-agent-owner?license_id=" + val
            }
          });
        }
      }
    },
    isFilterAdvanceClear: {
      handler: function (val, oldVal) {
        if (val == true) {
          // console.log("advance filter clear enable");
          this.filterRoomByAdvance();
        }
      }
    },
    isFilterAdvanceActive: {
      handler: function (val, oldVal) {
        if (val == true) {
          // console.log("advance filter enable");
          this.filterRoomByAdvance();
        }
      }
    },
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title || appTitle;
        this.currentTitle = to.meta.title || appTitle;
      }
    },
    "$route.query.phone": {
      handler(val) {
        if (val) {
          this.openRoomFromQuery();
        }
      }
    },
    RemoveRoomData: {
      handler: function (val, oldVal) {
        // console.log("RemoveRoomData:oldVal", oldVal);
        // console.log("newVal", val);
        if (val != null) {
          this.RemoveTakenRoomByOtherAgent(val.room_id, val.agent_id);
        }
      },
      deep: true
    },
    RefreshRoomData: {
      handler: function (val, oldVal) {
        // console.log("RefreshRoomData:oldVal", oldVal);
        // console.log("newVal", val);
        // if (oldVal != val && val != null) {
        //   this.getRoomList();
        // }
        if (val == true) {
          // this.playSound();
          this.numUnread();
          this.onlyGetRoomList();
          this.getNewNumUnreadMessageRoom();
          this.$store.dispatch("pusher/UpdateRefreshRoomData", false);
        }
      },
      deep: true
    },
    NEW_NUM_UNREAD_MESSAGE_ROOM_Data: {
      handler: function (val, oldVal) {
        // console.log("NEW_NUM_UNREAD_MESSAGE_ROOM_Data:oldVal", oldVal);
        // console.log("newVal", val);
        // if (oldVal != val && val != null) {
        //   this.getRoomList();
        // }
        this.numUnread();
        this.addNewRoom(val);
      },
      deep: true
    }
  },
  async created() {
    this.initLoading = await true;
    this.numUnread();
    this.changeRoomListArr([]);
    this.getNewNumUnreadMessageRoom();
    var that = this;
    setTimeout(function () {
      console.log("timeout");
      that.RefreshRoom();
    }, 200);

    await this.isOnline(this.agentSession.license_phone_number);
    await this.pollCheckIsOnline();
    this.initLoading = await false;
    this.$root.$on("addDirectChat", async dataArr => {
      const room = (await this.addNewRoom(dataArr)) || dataArr;
      this.switchRoom(
        room.id,
        room.room_title,
        room.room_photo,
        room.provider
      );
      // console.log("addDirectChat:", dataArr);
    });
    this.$root.$on("refreshRoomForContact", this.handleRefreshRoomForContact);
    this.$nextTick(() => this.openRoomFromQuery());
  },
  beforeDestroy() {
    clearInterval(this.checkIsOnline);
    this.$root.$off("addDirectChat");
    this.$root.$off("refreshRoomForContact", this.handleRefreshRoomForContact);
    this.RefreshRoomUnsub();
    this.$store.dispatch(
      "pusher/RefreshSenderNumberByMemberId_UNSUB",
      this.agentSession
    );
    this.$store.dispatch(
      "pusher/NEW_NUM_UNREAD_MESSAGE_ROOM_UNSUB",
      this.agentSession
    );
    this.$store.dispatch("pusher/RefreshRoomChat_UNSUB", this.activeRoomId);
  },
  methods: {
    showDateRoomList(timestamp) {
      return showDateRoomList(timestamp)
    },
    substringTitle: function (title, maxLength) {
      let newTitle = title
      if (title.trim() != "") {
        let lengthTitle = title.length
        if (lengthTitle > 0 && lengthTitle > maxLength) {
          newTitle = title.substr(0, maxLength) + "..."
        }
      }
      return newTitle;
    },
    showFilter() {
      this.activeId = "";
      this.changeActiveId("");
      var that = this;
      this.$store.dispatch("omniroom/setIsFilterAdvanceActive", false); //diset false dulu
      setTimeout(function () {
        var liContainer = document.getElementById("add_filters");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("omniroom/setIsShowFilter", true);
        }
      }, 1000);
    },
    async clearAll() {
      await this.$fire({
        title: "Are you sure you will Clear All chats?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        // console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store.dispatch("omniroom/clearAll").then(response => {
            this.$fire({
              title: "Success",
              text: response.msg,
              type: "warning",
              timer: 3000
            });
          });
        }
      });

      var that = this;
      setTimeout(function () {
        that.filterRoomByOptions(that.currentOptionsValue);
      }, 5000);
    },
    async readAll() {
      await this.$fire({
        title: "Are you sure you will Read All chats?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store.dispatch("omniroom/readAll").then(response => {
            this.$fire({
              title: "Success",
              text: response.msg,
              type: "warning",
              timer: 3000
            });
          });
        }
      });

      var that = this;
      setTimeout(function () {
        that.filterRoomByOptions(that.currentOptionsValue);
      }, 5000);
    },
    async resolveAll() {
      await this.$fire({
        title: "Are you sure you will Resolve All chats?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        //after click or after timer
        console.log("r.value", r.value); //button value
        if (typeof r.value != "undefined" && r.value == true) {
          this.$store.dispatch("omniroom/resolveAll").then(response => {
            this.$fire({
              title: "Success",
              text: response.msg,
              type: "warning",
              timer: 3000
            });
          });
        }
      });
    },
    playSound() {
      var audio = new Audio(this.incomingSound);
      audio.play();
    },
    showBroadcast() {
      this.activeId = "";
      this.changeActiveId("");
      var that = this;
      setTimeout(function () {
        var liContainer = document.getElementById("add_broadcast");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("omniroom/setIsShowBroadcast", true);
        }
      }, 1000);
    },
    showDirectChats() {
      this.$root.$emit("openDirectChat");
    },
    RemoveTakenRoomByOtherAgent(roomId, currentAgentId) {
      if (
        this.agentSession.id != "" &&
        this.agentSession.id != currentAgentId
      ) {
        if (this.roomListArr != null) {
          var index = this.roomListArr
            .map(x => {
              return x.id;
            })
            .indexOf(roomId);
          if (index >= 0) {
            this.roomListArr.splice(index, 1);
          }
        }
      }
    },
    async RefreshRoomUnsub() {
      this.$store.dispatch("pusher/RefreshRoom_UNSUB", this.agentSession);
    },
    async RefreshRoom() {

      this.$store.dispatch("pusher/RefreshRoom", this.agentSession);

      this.$store.dispatch("pusher/RefreshSenderNumberByMemberId", this.agentSession);
    },
    pollCheckIsOnline() {
      var that = this;
      this.checkIsOnline = setInterval(() => {
        that.isOnline(that.agentSession.license_phone_number);
        // console.log("pollCheckIsOnline", that.agentSession);
      }, 30000); //refresh per 30 detik
    },
    getWhatsappJid(number) {
      return getWhatsappJid(number);
    },
    async isOnline(phone) {
      this.loadingStatus = await true;

      await this.$store
        .dispatch("omniwa/isOnline", phone)
        .then(response => {
          var { data } = response;
          this.isOnlineData = data;
        })
        .catch(error => { });
      this.loadingStatus = await false;
    },
    normalizeRoomNumber(value) {
      const raw = String(value || "").trim();
      if (!raw) {
        return "";
      }
      const localPart = raw.split("@")[0];
      const digits = localPart.replace(/\D/g, "");
      return digits || localPart.toLowerCase();
    },
    isTemporaryRoom(room) {
      return !room || !room.id || room.id === "new-room";
    },
    getRoomLicense(room) {
      return (
        (room && room.license_id) ||
        (this.agentSession && this.agentSession.license_id) ||
        ""
      );
    },
    getRoomIdentifiers(room) {
      const values = [
        room && room.room_number,
        room && room.room_jid,
        room && room.room_lid
      ];
      return values
        .map(value => this.normalizeRoomNumber(value))
        .filter(value => !!value);
    },
    roomsMatch(first, second) {
      if (!first || !second) {
        return false;
      }
      const firstLicense = this.getRoomLicense(first);
      const secondLicense = this.getRoomLicense(second);
      if (
        firstLicense &&
        secondLicense &&
        firstLicense !== secondLicense
      ) {
        return false;
      }

      if (
        first.id &&
        second.id &&
        !this.isTemporaryRoom(first) &&
        !this.isTemporaryRoom(second) &&
        first.id === second.id
      ) {
        return true;
      }

      const firstNumbers = this.getRoomIdentifiers(first);
      const secondNumbers = this.getRoomIdentifiers(second);
      return firstNumbers.some(number => secondNumbers.indexOf(number) !== -1);
    },
    mergeRoomData(existing, incoming) {
      const existingTemporary = this.isTemporaryRoom(existing);
      const incomingTemporary = this.isTemporaryRoom(incoming);

      if (existingTemporary && !incomingTemporary) {
        return Object.assign({}, existing, incoming, { id: incoming.id });
      }
      if (!existingTemporary && incomingTemporary) {
        return Object.assign({}, incoming, existing, { id: existing.id });
      }

      // Jika dua room kanonis ternyata mewakili kontak yang sama, pertahankan
      // ID room yang sedang aktif agar percakapan tidak ter-reset.
      if (
        existing.id === this.activeRoomId &&
        incoming.id !== this.activeRoomId
      ) {
        return Object.assign({}, existing, incoming, { id: existing.id });
      }
      return Object.assign({}, existing, incoming, {
        id: incoming.id || existing.id
      });
    },
    mergeRoomList(rows, options = {}) {
      const list = options.replace ? [] : (this.roomListArr || []).slice();
      const promotedRooms = [];

      (rows || []).forEach(incoming => {
        if (!incoming) {
          return;
        }
        const matching = [];
        list.forEach((existing, index) => {
          if (this.roomsMatch(existing, incoming)) {
            matching.push({ room: existing, index: index });
          }
        });

        if (matching.length === 0) {
          if (options.prepend) {
            list.unshift(incoming);
          } else {
            list.push(incoming);
          }
          return;
        }

        const activeMatch = matching.find(item => {
          return item.room.id === this.activeRoomId;
        });
        const base = activeMatch || matching[0];
        const activeTemporary =
          this.isTemporaryRoom(base.room) &&
          base.room.id === this.activeRoomId;
        let merged = base.room;
        matching.forEach(item => {
          if (item !== base) {
            merged = this.mergeRoomData(merged, item.room);
          }
        });
        merged = this.mergeRoomData(merged, incoming);

        const removedIndexes = matching
          .map(item => item.index)
          .sort((a, b) => b - a);
        const indexesBeforeBase = matching.filter(item => {
          return item.index < base.index;
        }).length;
        removedIndexes.forEach(index => list.splice(index, 1));
        const insertAt = base.index - indexesBeforeBase;
        if (options.prepend) {
          list.unshift(merged);
        } else {
          list.splice(insertAt, 0, merged);
        }

        if (activeTemporary && !this.isTemporaryRoom(merged)) {
          promotedRooms.push(merged);
        }
      });

      this.$store.dispatch("omniroom/setRoomListArr", list);

      if (promotedRooms.length > 0) {
        const canonical = promotedRooms[0];
        this.switchRoom(
          canonical.id,
          canonical.room_title,
          canonical.room_photo,
          canonical.provider
        );
      }

      return promotedRooms;
    },
    async addNewRoom(dataArr) {
      if (!dataArr || !dataArr.id) {
        return dataArr;
      }
      this.mergeRoomList([dataArr], { prepend: true });
      return (
        (this.$store.state.omniroom.roomListArr || []).find(room =>
          this.roomsMatch(room, dataArr)
        ) || dataArr
      );
    },
    async getNewNumUnreadMessageRoom() {
      this.$store.dispatch(
        "pusher/NEW_NUM_UNREAD_MESSAGE_ROOM",
        this.agentSession
      );
    },
    async changeRoomListArr(data) {
      const newArr = [];
      (data || []).forEach(room => {
        const existingIndex = newArr.findIndex(existing =>
          this.roomsMatch(existing, room)
        );
        if (existingIndex === -1) {
          newArr.push(room);
        } else {
          newArr.splice(
            existingIndex,
            1,
            this.mergeRoomData(newArr[existingIndex], room)
          );
        }
      });
      this.$store.dispatch("omniroom/setRoomListArr", newArr);
    },
    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },
    changeActiveId(roomId) {
      this.$store.dispatch("omniroom/setActiveRoomId", roomId);
    },
    changeActiveProvider(provider) {
      this.$store.dispatch("omniroom/setActiveProvider", provider);
    },
    async switchRoom(roomId, roomTitle, roomPhoto, provider) {
      // if (this.activeRoomId != "" && this.activeRoomId == roomId) {
      //   return;
      // }
      this.loading = await true;
      if (this.activeId && this.activeId !== roomId) {
        this.$store.dispatch("pusher/RefreshRoomChat_UNSUB", this.activeId);
      }

      if (this.activeId != "" && this.$refs["ref-" + this.activeId]) {
        this.$refs["ref-" + this.activeId][0].classList.remove("active");
      }

      if (this.$refs["ref-" + roomId]) {
        this.$refs["ref-" + roomId][0].classList.add("active");
      }
      if (typeof this.$refs["ref-unread-" + roomId] != "undefined") {
        this.$refs["ref-unread-" + roomId][0].classList.add("hide");
        this.$refs["ref-unserved-" + roomId][0].classList.add("hide");
      }
      this.activeId = await roomId;
      // await this.changeActiveId(this.activeId);
      await this.changeActiveId(roomId);
      await this.changeActiveProvider(provider);

      // console.log("roomId:", roomId);
      // console.log("activeId:", this.activeId);
      var dataArr = [];
      dataArr = {
        room_id: roomId,
        room_title: roomTitle,
        room_photo: roomPhoto
      };
      await this.$root.$emit("switchRoom", dataArr);
      this.$store.dispatch("pusher/RefreshRoomChat", roomId);
      this.loading = await false;

      var that = this;
      //refresh pesan blm dibaca
      setTimeout(function () {
        that.numUnread();
      }, 200);
    },
    async numUnread() {
      // console.log("this.activeRoomId", this.activeRoomId);
      // console.log("this.serverParam", this.serverParam);
      this.loading = await true;
      await this.$store
        .dispatch("omniroom/numUnread", this.paramNumUnread)
        .then(response => {
          var { totalRecords } = response;
          if (totalRecords > 0) {
            document.title = "(" + totalRecords + ") " + this.currentTitle;
          } else {
            document.title = this.currentTitle;
          }
          // console.log("totalRecordstotalRecords",totalRecords)
        });
      this.loading = await false;
    },
    async onlyGetRoomList() {
      this.loading = true;
      try {
        const result = await this.$store.dispatch(
          "omniroom/getRoomList",
          this.serverParam
        );
        const rows = Array.isArray(result) ? result : result && result.data;
        if (Array.isArray(rows)) {
          // Merge, bukan append: respons API bisa berisi room yang sudah ada
          // di state lokal, termasuk room sementara hasil Chat Langsung.
          this.mergeRoomList(rows);
        }
      } finally {
        this.loading = false;
      }
    },
    async refreshRoomForContact(roomNumber) {
      const normalized = this.normalizeRoomNumber(roomNumber);
      if (!normalized) {
        return null;
      }

      try {
        const result = await this.$store.dispatch("omniroom/getRoomList", {
          ...this.serverParam,
          keywords: normalized,
          page: 0,
          rendered: 0
        });
        const rows = Array.isArray(result) ? result : (result && result.data) || [];
        this.mergeRoomList(rows);
        return (
          rows.find(room => {
            return this.getRoomIdentifiers(room).indexOf(normalized) !== -1;
          }) || null
        );
      } catch (error) {
        return null;
      }
    },
    async handleRefreshRoomForContact(payload) {
      if (!payload || !payload.room_number) {
        return;
      }

      let canonical = await this.refreshRoomForContact(payload.room_number);
      if (!canonical && this.activeRoomId === "new-room") {
        await new Promise(resolve => setTimeout(resolve, 900));
        canonical = await this.refreshRoomForContact(payload.room_number);
      }
    },
    async fetchRoomsByKeyword(roomNumber, options) {
      const normalized = this.normalizeRoomNumber(roomNumber);
      if (!normalized) {
        return [];
      }

      try {
        const result = await this.$store.dispatch("omniroom/getRoomList", {
          keywords: normalized,
          options: options || "",
          tags_filter: false,
          untag: false,
          tags_id: [],
          page: 0,
          perPage: 30,
          rendered: 0,
          totalRecords: 0
        });
        return Array.isArray(result) ? result : (result && result.data) || [];
      } catch (error) {
        return [];
      }
    },
    isRoomForActiveLicense(room) {
      if (!room) {
        return false;
      }
      const roomLicenseId = room.license_id;
      const activeLicenseId =
        this.agentSession && this.agentSession.license_id;
      if (!roomLicenseId || !activeLicenseId) {
        return true;
      }
      return String(roomLicenseId) === String(activeLicenseId);
    },
    findRoomById(roomId) {
      if (!roomId) {
        return null;
      }
      const room =
        (this.roomListArr || []).find(item => {
          return String(item.id) === String(roomId);
        }) || null;
      return room && this.isRoomForActiveLicense(room) ? room : null;
    },
    async findRoomForQuery(phone, roomId) {
      const byId = this.findRoomById(roomId);
      if (byId) {
        return byId;
      }

      const normalized = this.normalizeRoomNumber(phone);
      if (!normalized) {
        return null;
      }

      let phoneMatch = null;
      // Room yang sudah selesai tidak muncul pada filter default, jadi
      // pencarian juga dilakukan pada daftar resolved agar sesi closed
      // tetap dapat dibuka.
      const optionSets = ["", "resolved"];
      for (let index = 0; index < optionSets.length; index++) {
        const rows = await this.fetchRoomsByKeyword(normalized, optionSets[index]);
        if (roomId) {
          const roomById = rows.find(room => {
            return (
              String(room.id) === String(roomId) &&
              this.isRoomForActiveLicense(room)
            );
          });
          if (roomById) {
            return roomById;
          }
        }
        if (!phoneMatch) {
          phoneMatch =
            rows.find(room => {
              return (
                this.getRoomIdentifiers(room).indexOf(normalized) !== -1 &&
                this.isRoomForActiveLicense(room)
              );
            }) || null;
        }
      }

      return phoneMatch;
    },
    // Membuka percakapan tertentu setelah masuk ke /omni. Parameter hanya
    // berisi license_id, phone, dan room_id (tanpa token/kredensial).
    async openRoomFromQuery() {
      if (this.queryRoomOpening) {
        return;
      }

      const query = this.$route.query || {};
      const phone = query.phone;
      const roomId = query.room_id;
      if (!phone && !roomId) {
        return;
      }

      const targetLicenseId = query.license_id;
      const activeLicenseId = this.agentSession && this.agentSession.license_id;
      if (
        targetLicenseId &&
        activeLicenseId &&
        String(targetLicenseId) !== String(activeLicenseId)
      ) {
        this.$fire({
          title: "Lisensi Tidak Sesuai",
          text:
            "Lisensi aktif tidak sama dengan lisensi sesi AI Chat. Buka kembali dari halaman Sesi AI Chat.",
          type: "error",
          timer: 4000
        });
        return;
      }

      this.queryRoomOpening = true;
      try {
        const room = await this.findRoomForQuery(phone, roomId);
        if (!room) {
          this.$fire({
            title: "Percakapan Belum Tersedia",
            text:
              "Belum ada percakapan dengan nomor " +
              (this.normalizeRoomNumber(phone) || "-") +
              " pada lisensi ini.",
            type: "info",
            timer: 4000
          });
          return;
        }

        this.mergeRoomList([room], { prepend: true });
        await this.switchRoom(
          room.id,
          room.room_title,
          room.room_photo,
          room.provider
        );
      } finally {
        this.queryRoomOpening = false;
      }
    },
    async filterRoomByAdvance() {
      this.activeId = "";
      this.changeActiveId("");
      this.changeRoomListArr([]);
      //   console.log("groupId", groupId);
      this.serverParam.totalRecords = 0;
      this.serverParam.rendered = 0;
      if (this.filterRoomAdvance.tags_filter == true) {
        this.serverParam.untag = this.filterRoomAdvance.untag;
        this.serverParam.tags_filter = this.filterRoomAdvance.tags_filter;
        let tagsId = "";
        this.serverParam.tags_id = "";
        if (this.filterRoomAdvance.tags_id.length > 0) {
          this.filterRoomAdvance.tags_id.forEach((tagId, idx) => {
            // this.serverParam.tags_id.push(tagId);
            if (idx == 0) {
              this.serverParam.tags_id = tagId;
            } else {
              this.serverParam.tags_id += "," + tagId;
            }
          });
        }
      } else {
        this.serverParam.untag = false;
        this.serverParam.tags_id = "";
        this.serverParam.tags_filter = false;
      }

      this.serverParam.page = 0;
      this.serverParam.perPage = 30;
      this.infiniteId += 1;
    },
    async filterRoomByKeywords() {
      this.activeId = "";
      this.changeActiveId("");
      this.changeRoomListArr([]);
      //   console.log("groupId", groupId);
      this.serverParam.totalRecords = 0;
      this.serverParam.rendered = 0;
      this.serverParam.page = 0;
      this.serverParam.perPage = 30;
      this.infiniteId += 1;
    },
    async filterRoomByOptions(optionsValue) {
      this.activeId = "";
      this.changeActiveId("");
      this.changeRoomListArr([]);
      //   console.log("groupId", groupId);
      this.serverParam.totalRecords = 0;
      this.serverParam.rendered = 0;
      this.serverParam.options = optionsValue;
      this.serverParam.page = 0;
      this.serverParam.perPage = 30;
      this.infiniteId += 1;
      this.currentOptionsValue = optionsValue;
    },
    async getRoomList($state) {
      // console.log("staaatex", $state);

      // console.log("this.activeRoomId", this.activeRoomId);
      this.loading = await true;
      await this.$store
        .dispatch("omniroom/getRoomList", this.serverParam)
        .then(result => {
          const { data } = result;
          this.newData = data;
          if (this.newData.length > 0) {
            this.roomListArr.push(...this.newData);
            this.mergeRoomList(this.roomListArr);
            this.serverParam.rendered =
              this.serverParam.page + result.recordsFiltered;
            this.serverParam.page += result.recordsFiltered;

            if (typeof result.data != "undefined" && result.data != null) {
              result.data.forEach((row, index) => {
                if (row.id == this.activeRoomId && this.activeRoomId != "") {
                  var dataArr = {
                    room_id: row.id,
                    room_title: row.room_title,
                    room_photo: row.room_photo
                  };
                  // console.log("prov::", row.provider);
                  this.switchRoom(
                    row.id,
                    row.room_title,
                    row.room_photo,
                    row.provider
                  );
                  return;
                }
              });
            }

            if (result.totalRecords > 0) {
              this.serverParam.totalRecords = result.totalRecords;
            }

            this.loadingMessage = false;
            $state.loaded();
          } else {
            this.loading = false;
            $state.completed();
          }
        })
        .catch(error => {
          //   this.loading = false;
          this.loading = false;

          console.log("error", error);
        });
      this.loading = await false;
    }
  }
};
</script>
<style>
.hide {
  visibility: hidden !important;
}

.sidebar {
  height: 100vh;
  overflow: auto;
}

.sidebar::-webkit-scrollbar {
  width: 7px;
}

/* Track */
.sidebar::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 5px grey;  */
  box-shadow: none;
  border-radius: 10px;
}

/* Handle */
.sidebar::-webkit-scrollbar-thumb {
  /* background: red;  */
  border-radius: 10px;
  /* background: rgb(204, 204, 204); */
  background-color: transparent;
}

/* Handle on hover */
.sidebar::-webkit-scrollbar-thumb:hover {
  /* background: #b30000;  */
  background: rgb(204, 204, 204);
}

.sidebar-menu ul ul a.class-active {
  color: #00c5fb;
  text-decoration: underline;
}

/* ============================= INBOX MODERN ============================= */

.waajo-inbox-sidebar {
  background: #ffffff;
  border-right: 1px solid #eef2f7;
}

.waajo-inbox {
  padding: 14px 10px 24px;
}

.waajo-inbox-head {
  padding: 0 2px;
}

.waajo-inbox-account {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px;
  background: linear-gradient(135deg, #fff7e8 0%, #fffdf8 100%);
  border: 1px solid #f6e3bd;
  border-radius: 14px;
}

.waajo-inbox-account-icon {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #ffffff;
  background: #f39c12;
  border-radius: 11px;
  font-size: 19px;
}

.waajo-inbox-status {
  position: absolute;
  right: -2px;
  bottom: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 15px;
  background: #ffffff;
  border-radius: 50%;
  font-size: 8px;
}

.waajo-inbox-account-copy {
  flex: 1;
  min-width: 0;
}

.waajo-inbox-account-copy strong {
  display: block;
  overflow: hidden;
  color: #101828;
  font-size: 12px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-inbox-license-name {
  display: block;
  margin-top: 1px;
  overflow: hidden;
  color: #475467;
  font-size: 10.5px;
  font-weight: 600;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-inbox-account-copy small {
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  margin-top: 2px;
  overflow: hidden;
  color: #667085;
  font-size: 10px;
  white-space: nowrap;
}

.waajo-inbox-agent-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-inbox-owner-badge {
  flex: 0 0 auto;
  padding: 1px 5px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 8px;
  font-weight: 700;
}

.waajo-inbox-search {
  position: relative;
  display: flex;
  align-items: center;
  gap: 7px;
  height: 38px;
  padding: 0 8px 0 11px;
  margin-top: 11px;
  background: #f8fafc;
  border: 1px solid #e7edf5;
  border-radius: 10px;
}

.waajo-inbox-search > i {
  color: #98a2b3;
  font-size: 12px;
}

.waajo-inbox-search input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  font-size: 11px;
}

.waajo-inbox-search input::placeholder {
  color: #98a2b3;
}

.waajo-inbox-filter {
  flex: 0 0 auto;
}

.waajo-inbox-filter-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 8px;
  font-size: 11px;
  cursor: pointer;
}

.waajo-filter-dot {
  position: absolute;
  top: -3px;
  right: -3px;
  font-size: 6px;
}

.waajo-inbox-filter .dropdown-menu {
  min-width: 195px;
  padding: 6px;
  border: 1px solid #e7edf5;
  border-radius: 11px;
  box-shadow: 0 16px 34px rgba(15, 23, 42, 0.16);
}

.waajo-inbox-filter .dropdown-item {
  padding: 7px 9px;
  color: #344054;
  border-radius: 7px;
  font-size: 11px;
}

.waajo-inbox-filter .dropdown-item:hover {
  color: #b36b00;
  background: #fffaf1;
}

.waajo-inbox-filter .dropdown-divider {
  margin: 3px 0;
}

.waajo-inbox-live {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 10px;
  margin-top: 9px;
  color: #b36b00;
  background: #fffaf1;
  border: 1px solid #f6e3bd;
  border-radius: 10px;
  text-align: left;
  cursor: pointer;
}

.waajo-inbox-live:hover {
  background: #fff3df;
  border-color: #f6d49b;
}

.waajo-inbox-live-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  color: #ffffff;
  background: #f39c12;
  border-radius: 8px;
  font-size: 13px;
}

.waajo-inbox-live-copy {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 1px;
}

.waajo-inbox-live-copy strong {
  color: #8f5600;
  font-size: 10px;
  font-weight: 700;
}

.waajo-inbox-live-copy small {
  color: #98a2b3;
  font-size: 9px;
}

.waajo-inbox-live > .fa-chevron-right {
  color: #c99a55;
  font-size: 9px;
}

.waajo-inbox-tabs {
  display: flex;
  gap: 5px;
  padding: 4px;
  margin-top: 10px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 11px;
}

.waajo-inbox-tabs button {
  flex: 1;
  height: 30px;
  padding: 0 5px;
  color: #667085;
  background: transparent;
  border: 0;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.18s ease;
}

.waajo-inbox-tabs button.is-active {
  color: #ffffff;
  background: #f39c12;
  box-shadow: 0 4px 10px rgba(243, 156, 18, 0.22);
}

.waajo-room-list {
  padding: 0 !important;
  margin: 10px 0 0 !important;
  list-style: none;
}

.waajo-room-item {
  margin-bottom: 3px;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-room-link {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 10px 9px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: 12px;
  text-decoration: none;
  transition: background-color 0.18s ease, border-color 0.18s ease;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-room-link:hover {
  background: #fffaf1;
}

.waajo-room-item.active .waajo-room-link {
  background: #fff7e8;
  border-color: #f6d49b;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-room-link > span {
  margin-left: 0;
}

.waajo-room-avatar {
  position: relative;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
}

.waajo-room-avatar img {
  width: 38px;
  height: 38px;
  object-fit: cover;
}

.waajo-room-dot {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 9px;
  height: 9px;
  margin-left: 0 !important;
  background: #22c55e;
  border: 2px solid #ffffff;
  border-radius: 50%;
}

.waajo-room-main {
  display: flex !important;
  flex: 1;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
  margin-left: 0 !important;
  white-space: normal !important;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-room-main span {
  margin-left: 0;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-room-main .waajo-room-top,
.waajo-inbox-sidebar .waajo-inbox .waajo-room-main .waajo-room-bottom,
.waajo-inbox-sidebar .waajo-inbox .waajo-room-main .waajo-room-flags {
  display: flex;
}

.waajo-room-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  min-width: 0;
}

.waajo-room-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: #101828;
  font-size: 11px;
  font-weight: 700;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-room-time {
  flex: 0 0 auto;
  color: #98a2b3;
  font-size: 8px;
  white-space: nowrap;
}

.waajo-room-bottom {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}

.waajo-room-snippet {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: #667085;
  font-size: 9px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  margin-left: auto !important;
  color: #ffffff;
  background: #f39c12;
  border-radius: 20px;
  font-size: 8px;
  font-weight: 700;
}

.waajo-room-flags {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 0 !important;
  white-space: normal !important;
}

.waajo-unserved {
  padding: 1px 6px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
  font-size: 8px;
}

.waajo-inbox-sidebar .waajo-inbox .waajo-resolved {
  padding: 1px 6px;
  margin-left: 0 !important;
  color: #067647;
  background: #ecfdf3;
  border: 1px solid #abefc6;
  border-radius: 20px;
  font-size: 8px;
  font-weight: 600;
}

.waajo-inbox .hide {
  display: none !important;
}

.waajo-room-loading,
.waajo-room-empty {
  padding: 14px 8px;
  color: #98a2b3;
  font-size: 11px;
  text-align: center;
}

.waajo-inbox .infinite-loading {
  padding: 6px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/omni/LeftSidebar.vue